import React from 'react'
import styled from 'styled-components'
import { Button, Grid } from 'semantic-ui-react'

import IntegrationWebhookSegment from 'organisms/IntegrationWebhookSegment'
import IntegrationWebhookModal from 'components/IntegrationWebhookModal'

/**
 * @param {object} props
 * @param {import('components/IntegrationWebhookModal').WebhookSetting[]} props.webhookSettings
 * @param {function} props.onCreateWebhookSetting
 * @param {function} props.onUpdateWebhookSetting
 * @param {function} props.onDeleteWebhookSetting
 * @param {function} props.onUpdateWebhookEvent
 * @param {'slack' | 'microsoft_teams'} props.type
 * @param {'Slack' | 'Microsoft Teams'} props.title
 * @param {boolean} props.modalOpen
 * @param {boolean} props.saveButtonLoading
 * @param {number} props.selectedWebhookSettingIndex
 * @param {function} props.openAddChannelModal
 * @param {function} props.closeModal
 * @param {function} props.handleSegmentSelect
 */
export function WebhookIntegration({
  modalOpen,
  webhookSettings,
  saveButtonLoading,
  selectedWebhookSettingIndex,
  onCreateWebhookSetting,
  onUpdateWebhookSetting,
  onDeleteWebhookSetting,
  onUpdateWebhookEvent,
  type,
  title,
  openAddChannelModal,
  closeModal,
  handleSegmentSelect,
}) {
  return (
    <React.Fragment>
      <div className="admin-heading">
        <h2>Send feedback to {title}</h2>
      </div>
      <div className="ui stackable grid">
        <div className="twelve wide column">
          <p>
            View Simplesat responses and summaries in {title}, the app you already have open all
            day. You can route feedback from specific surveys to any channel.
          </p>
          <p>This feature uses {title}'s Incoming Webhooks integration.</p>
          <p>To get started, add a channel and configure your notification preferences.</p>
          <p>
            <a
              href={
                title === 'Slack'
                  ? 'https://help.simplesat.io/en/articles/4139955'
                  : 'https://help.simplesat.io/en/articles/9581676-microsoft-teams-integrations'
              }
              target="_blank"
              rel="noreferrer"
            >
              <i className="icon far fa-book" />
              Integrating {title} with Simplesat
            </a>
          </p>
          <IntegrationWebhookModal
            modalOpen={modalOpen}
            type={type}
            webhookSetting={webhookSettings[selectedWebhookSettingIndex]}
            onModalClose={closeModal}
            onCreate={onCreateWebhookSetting}
            onUpdate={onUpdateWebhookSetting}
            onUpdateEvent={onUpdateWebhookEvent}
            saveButtonLoading={saveButtonLoading}
          />
          <hr />
          <Grid columns={2}>
            <Grid.Row verticalAlign="middle">
              <Grid.Column>
                <h3>Channels</h3>
              </Grid.Column>
              <Grid.Column style={{ textAlign: 'right' }}>
                <Button primary onClick={openAddChannelModal} className="mr0">
                  <i className="icon far fa-plus" />
                  Add new channel
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <span />
          {webhookSettings.length > 0 && (
            <Segments className="ui segments">
              {webhookSettings.map((webhookSetting, index) => {
                return (
                  <IntegrationWebhookSegment
                    key={webhookSetting.id}
                    webhookSetting={webhookSetting}
                    onDelete={() => onDeleteWebhookSetting(webhookSetting, index)}
                    onSelect={() => handleSegmentSelect(index)}
                  />
                )
              })}
            </Segments>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

const Segments = styled.div`
  .ui.segment {
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  &.ui.segments .ui.segment:only-of-type {
    border: none;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/WebhookIntegration/index.js